import { createContext } from 'react';
var defaultContext = {
    breakpoints: {},
    currentBreakpoint: '',
};
export var BreakpointsContext = createContext(defaultContext);
BreakpointsContext.displayName = 'ReactBreakpoints';
//# sourceMappingURL=BreakpointsContext.js.map